import axios from 'axios';
import type { IGetSupraSubscriptionAnyStatusResponse } from '@/app-package';

const getSupraSystemSubscription = async (params: {
  userId: string;
}): Promise<IGetSupraSubscriptionAnyStatusResponse> => {
  const { data } = await axios.get<IGetSupraSubscriptionAnyStatusResponse>(
    `/supra_system/subscriptions/${params.userId}`,
  );

  return data ?? null;
};

export default getSupraSystemSubscription;
